import { Routes, Route } from 'react-router';
import { AppShell } from '@mantine/core';
import { Header } from '@components/Header';
import { Footer } from '@components/Footer';
import { HomePage } from '@pages/HomePage';
import { FacilityPage } from '@pages/FacilityPage';
import { ServicesPage } from '@pages/ServicesPage';
import { AboutPage } from '@pages/AboutPage';
import { ContactPage } from '@pages/ContactPage';
import { StaffingPage } from '@pages/StaffingPage';
import { LunchOnUsPage } from '@pages/LunchOnUsPage';
import { PortalFormPage } from '@pages/PortalFormPage';
import { AddAppointmentPage } from '@pages/AddAppointmentPage';

function App() {
  return (
    <AppShell header={{ height: 70 }} padding={0}>
      <AppShell.Header>
        <Header />
      </AppShell.Header>
      <AppShell.Main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/facility" element={<FacilityPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/staffing" element={<StaffingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/lunch-on-us" element={<LunchOnUsPage />} />
          <Route path="/staff/appointments/add" element={<AddAppointmentPage />} />
          <Route path="/forms/:portalSlug/:workflowSlug" element={<PortalFormPage />} />
        </Routes>
        <Footer />
      </AppShell.Main>
    </AppShell>
  );
}

export default App;
